import { Radio, LogOut, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

const PlanBadge = ({ user, onUpgrade }) => {
  const left = user.free_decodes_left + user.credits;
  return (
    <div className="flex items-center gap-2">
      <span data-testid="plan-badge" className={`font-mono-display text-[10px] tracking-[0.2em] uppercase px-3 py-2 border ${
        left > 0 ? "border-emerald-500/60 text-emerald-500" : "border-white/15 text-zinc-300"}`}>
        {left} decode{left === 1 ? "" : "s"} left
      </span>
      <Button onClick={onUpgrade} data-testid="upgrade-btn"
        className="rounded-none h-9 bg-fuchsia-500 hover:bg-fuchsia-400 text-black font-mono-display text-[10px] tracking-[0.2em] uppercase font-bold">
        <Zap className="w-3 h-3 mr-1" /> Buy decodes
      </Button>
    </div>
  );
};

export const DecoderHeader = ({ onUpgrade }) => {
  const { user, logout } = useAuth() || {};
  return (
    <header className="border-b border-white/10 bg-black/60 backdrop-blur-xl sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3" data-testid="app-logo">
          <img src="/logo192.png" alt="Song2Suno logo" width="40" height="40" className="w-10 h-10 ring-1 ring-emerald-500/30 rounded-[9px]" data-testid="app-logo-mark" />
          <div className="leading-tight">
            <div className="font-mono-display text-sm font-black tracking-tighter text-white">
              SONG<span className="text-emerald-500">2</span>SUNO
            </div>
            <div className="font-mono-display text-[10px] tracking-[0.3em] uppercase text-zinc-500 hidden sm:block">audio → prompt engine</div>
          </div>
        </div>
        {user ? (
          <div className="flex items-center gap-3">
            <PlanBadge user={user} onUpgrade={onUpgrade} />
            <Button onClick={logout} variant="ghost" size="icon" aria-label="Log out" data-testid="logout-btn"
              className="rounded-none h-9 w-9 text-zinc-400 hover:text-white hover:bg-white/5">
              <LogOut className="w-4 h-4" />
            </Button>
          </div>
        ) : (
          <div className="hidden sm:flex items-center gap-2 text-[10px] font-mono-display tracking-[0.2em] uppercase text-zinc-500">
            <Radio className="w-3 h-3 text-emerald-500 flicker" /><span>gemini 3.1 pro // online</span>
          </div>
        )}
      </div>
    </header>
  );
};
